import 'slick-carousel';

export class Slider {
	constructor() {
		this.container = document.querySelector('.slider');
		this.slider = this.container.querySelector('.slider-container');
		this.buttons = this.container.querySelectorAll(
			'.slider-buttons button'
		);

		this.eventAnimIteration = this.onAnimationIteration.bind(this);
	}

	init() {
		this.onInitSlider();
		this.onChangeSlide();
		$(this.slider).slick({
			prevArrow: this.container.querySelector('.slider-prev'),
			nextArrow: this.container.querySelector('.slider-next'),
		});

		this.buttons.forEach((button) => {
			button.addEventListener('click', () => {
				this.removeCountdown();
			});
		});
	}

	onInitSlider() {
		$(this.slider).on('init', () => {
			this.container
				.querySelector('.slider-next circle')
				.addEventListener(
					'animationiteration',
					this.eventAnimIteration
				);
		});
	}

	onChangeSlide() {
		const currentSlideContainer =
			this.container.querySelector('.currentSlide');

		$(this.slider).on('afterChange', function () {
			const currentSlideIndex = $(this).slick('slickCurrentSlide') + 1;

			currentSlideContainer.textContent =
				currentSlideIndex >= 10
					? currentSlideIndex
					: `0${currentSlideIndex}`;
		});
	}

	onAnimationIteration() {
		this.autoAdvance();
	}

	autoAdvance() {
		$(this.slider).slick('slickNext');
	}

	removeCountdown() {
		this.container.querySelector('.slider-next').classList.add('stopAnim');
	}
}
